export default __webpack_public_path__ + "static/img/footer_ico_en.ef46299.png";